<div class="modal fade" tabindex="-1" role="dialog" bsModal #modal="bs-modal">
    <div class="modal-dialog modal-dialog-centered quickview">
        <div *ngIf="product" class="modal-content">
            <button type="button" class="quickview__close" (click)="modal.hide()">
                <app-icon icon="cross-12"></app-icon>
            </button>
            <div class="quickview__body">
               {{ product|json}}
            </div>

        </div>
    </div>
</div>
